import React, { useState } from "react";
import Contacts from "@/pages/contacts";
const Canadainvestorvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/cannads.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
        </div>
      </div>
      <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
        <p className="mb-5 text-center text-4xl font-bold text-[#011473] md:text-4xl">
          Key Documents for Canadian Investor Visa Application
        </p>
        <div className="px-8 py-12 md:py-20">
          <div className="2xl:gap-12 grid grid-cols-1  gap-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
            {[
              {
                href: "#", // Update this if needed
                title: "Valid Passport",
                description: "Must be valid for at least six months.",
                imgSrc: "/turist.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Proof of Net Worth",
                description:
                  "Financial statements, asset ownership documents, and bank statements.",
                imgSrc: "/bussines.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Source of Funds",
                description:
                  "Documents proving the legal origin of your funds.",
                imgSrc: "/visits.JPG",
              },
              {
                href: "#", // Update this if needed
                title: "Business Experience",
                description:
                  "Resume, business ownership/proof, and financial statements.",
                imgSrc: "/medical.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Investment Agreement",
                description:
                  "Agreement for investment in Canada and proof of fund transfer.",
                imgSrc: "/students.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Language Proficiency",
                description:
                  "Test results (IELTS, CELPIP for English; TEF, TCF for French).",
                imgSrc: "/stay.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Medical Exam",
                description: "Report from an approved physician.",
                imgSrc: "/passports.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Police Clearance",
                description:
                  "Certificates from all countries where you lived for six months or more.",
                imgSrc: "/transit.JPG",
              },
              {
                href: "#", // Update this if needed
                title: "Proof of Business Ownership",
                description:
                  "Relevant business documents like shareholder agreements.",
                imgSrc: "/air.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Business Plan",
                description:
                  "Detailed plan with market analysis and financial projections.",
                imgSrc: "/passports.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Fee Receipts",
                description: "Proof of payment for visa processing fees.",
                imgSrc: "/fees.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Recent Photos",
                description:
                  "Passport-sized photos as per IRCC specifications.",
                imgSrc: "/recentphoto.jpg",
              },
              {
                href: "#", // Update this if needed
                title: "Travel History",
                description:
                  "Record of your international travel over the past 10 years.",
                imgSrc: "/transit.JPG",
              },
              {
                href: "#", // Update this if needed
                title: "Additional Support",
                description:
                  "Letters from Canadian business partners or authorities.",
                imgSrc: "/support.jpg",
              },
            ].map((resource, index) => (
              <div
                key={index}
                data-aos="fade-up"
                className="group relative h-auto w-full overflow-hidden rounded-3xl border border-black font-sans hover:shadow-lg md:w-[300px] lg:w-[320px]"
              >
                <a href={resource.href} className="block">
                  <div className="px-2 py-2">
                    <div className="relative h-[190px] w-full overflow-hidden rounded-2xl md:h-[200px] lg:h-[250px]">
                      <img
                        src={resource.imgSrc}
                        alt={resource.title}
                        className="absolute left-0 top-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                    </div>
                  </div>
                  <div className="p-8">
                    <h3 className="font-syne mb-2 text-[20px] font-medium text-[#011473]">
                      {resource.title}
                    </h3>
                    <p className="text-sm font-medium text-black">
                      {resource.description}
                    </p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
      <p className="mb-5 text-left text-2xl font-bold text-[#011473] md:ml-32 md:w-2/3 md:text-2xl">
        Benefits of the Immigrant Investor Program to Canada
      </p>
      <div className="space-y-4 text-center md:ml-32 md:text-left">
        <div className="flex items-center justify-center md:justify-start">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-left font-medium text-gray-700">
            <a className="font-bold text-black"> Guaranteed Investment:</a> A
            $1.2 million investment in Canada, secured by the Government of
            Quebec.
          </span>
        </div>

        <div className="flex items-center justify-center md:justify-start">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-left font-medium text-gray-700">
            <a className="font-bold text-black">
              {" "}
              Support for Local Businesses:
            </a>{" "}
            Interest from the investment funds intermediary brokerage firms and
            provides 0% interest loans to small businesses.
          </span>
        </div>

        <div className="flex items-center justify-center md:justify-start">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-left font-medium text-gray-700">
            <a className="font-bold text-black">Social Impact:</a> The
            investment helps fund refugee sponsorship programs and other
            immigration initiatives, benefiting society at large.
          </span>
        </div>

        <div className="flex items-center justify-center md:justify-start">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-left font-medium text-gray-700">
            <a className="font-bold text-black">Economic Growth:</a> Investor
            contributions directly support Canada's economic development,
            creating job opportunities in Quebec and across Canada.
          </span>
        </div>

        <div className="flex items-center justify-center md:justify-start">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 text-left font-medium text-gray-700">
            <a className="font-bold text-black">Path to PR: </a>Canada grants
            investors and their families permanent residency, bypassing standard
            immigration requirements.
          </span>
        </div>

        <div className="flex items-center justify-center md:justify-start">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <span className="ml-3 font-medium text-gray-700">
            <a className="font-bold text-black">A Wise Investment: </a>This can
            be one of the best investments you make for both your future and
            Canada's prosperity.
          </span>
        </div>
      </div>
      <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
        <p className="mb-5 text-center text-3xl font-bold text-[#011473] md:text-5xl">
          How Canada Benefits from Your Investment
        </p>
        <div className="container mx-auto mb-10 mt-14">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-2">
            <div className="flex items-center justify-center">
              <img
                src="/bussines.jpg" // Replace with your image URL
                alt="Investment"
                className="h-auto w-full rounded-xl shadow-md"
              />
            </div>
            <div className="justify-left flex flex-col pl-4 text-left md:text-left">
              <p className="mb-4 text-lg text-black">
                By investing CAD 1,200,000 through the Quebec Immigrant Investor
                Program, you contribute to Canada’s economy in several ways:
              </p>
              <ul className="mb-4 list-disc pl-5 text-black">
                <li>
                  <strong className="font-bold text-black">
                    Support for Small Businesses:
                  </strong>{" "}
                  Interest from your investment funds 0% loans for local
                  businesses in Quebec.
                </li>
                <li>
                  <strong className="font-bold text-black">
                    Social Initiatives:
                  </strong>{" "}
                  The remaining interest supports refugee sponsorships and other
                  immigration programs.
                </li>
                <li>
                  <strong className="font-bold text-black">
                    Job Creation:
                  </strong>{" "}
                  Your investment helps stimulate economic growth and job
                  opportunities in Quebec and beyond.
                </li>
              </ul>
              <p className="text-lg text-black">
                In return, you gain the opportunity to become a Canadian
                Permanent Resident, bypassing many requirements of other
                immigration programs. It’s a mutually beneficial investment that
                supports both you and Canadian society.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
        <p className="md:ml-86 mb-5 justify-center text-center  text-4xl font-bold text-[#011473] md:text-4xl">
          Federal Immigrant Investor Program (Now Closed)
        </p>

        <div className="container mx-auto mb-10 mt-14">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-2">
            <div className="flex flex-col justify-center pl-4 text-left md:text-left">
              <p className="mb-4 text-lg text-black">
                <strong>Eligibility Criteria for Investor Applicants:</strong>
              </p>
              <ul className="mb-4 list-disc pl-5 text-black">
                <li>
                  <strong className="font-bold text-black">Net Worth:</strong> A
                  minimum of $1.6 million in assets.
                </li>
                <li>
                  <strong className="font-bold text-black">
                    Relevant Experience:
                  </strong>{" "}
                  Significant managerial experience in a business, including
                  commercial, industrial, agricultural, or professional sectors.
                </li>
                <li>
                  <strong className="font-bold text-black">
                    Investment Requirement:
                  </strong>{" "}
                  Willingness to make a government-secured investment of
                  $800,000.
                </li>
                <li>
                  <strong className="font-bold text-black">
                    Financing Options:
                  </strong>{" "}
                  Financing for this investment is available through Canadian
                  financial institutions.
                </li>
              </ul>
              <p className="mb-4 text-lg text-black">
                As an approved investor, both you and your immediate family are
                eligible to obtain Canadian Permanent Resident Visas under this
                program, which allows for settlement anywhere in Canada,
                excluding Quebec.
              </p>
              <p className="text-lg text-black">
                This government-secured program guarantees a full refund of the
                $800,000 investment, without interest, after a five-year period.
              </p>
            </div>
            <div className="flex items-center justify-center">
              <img
                src="/invester.jpg" // Replace with your image URL
                alt="Investor Program"
                className="h-96 w-full rounded-xl shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col items-center justify-center py-20">
        {isOpen && (
          <div className="mb-6 w-3/4 items-center justify-center text-black rounded-md bg-gray-100 p-4 text-lg shadow-md">
            <p>
              Canada is widely regarded as one of the top countries for starting
              a business, thanks to its abundant natural resources, skilled
              workforce and stable government. The Canada Investor Program
              caters to individuals who wish to immigrate as entrepreneurs or
              investors, offering a variety of visa options to suit different
              business needs. Key pathways include the popular Start-up Visa
              Program and Provincial Nominee Programs, among others. Upon a
              successful application, applicants and their families can relocate
              to Canada.
              <br />
              <br />
              Notable business immigration programs under the Canada Investor
              Visa include:
              <br />
              - Quebec Immigrant Investor Program (QIIP)
              <br />
              - Quebec Entrepreneur Program
              <br />
              - Quebec Self-Employed Program
              <br />
              - Provincial Nominee Entrepreneur Programs
              <br />
              - Federal Immigrant Investor Program
              <br />
              - Federal Start-Up Visa Program
              <br />
              These programs provide excellent opportunities for entrepreneurs
              and investors to settle and build businesses in Canada.
            </p>
          </div>
        )}
        <button
          onClick={toggleAnswer}
          className="w-2/2 flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 md:w-1/2"
        >
          Canada Investor Visa – Business Immigration Programs
          <svg
            className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 5v14M5 12l7 7 7-7"></path>
          </svg>
        </button>
      </div>
      |
      <Contacts />
    </>
  );
};

export default Canadainvestorvisa;
